import { Redirect } from "react-router-dom";

export const OnboardingSettingsPage = () => (
  <Redirect to="/members/onboarding" />
);
